var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.done
    ? _c("div", { staticClass: "m-3" }, [
        _c(
          "div",
          { staticClass: "d-flex flex-column flex-md-row gap-4 mb-3" },
          [
            _c(
              "div",
              {
                staticClass:
                  "brand-sidebar p-3 d-flex flex-column align-items-center text-center text-md-left align-items-md-start"
              },
              [
                !_vm.imageUrl
                  ? [
                      _c(
                        "div",
                        {
                          staticClass:
                            "logo-container border bg-light w-100 d-flex flex-column align-items-center rounded justify-content-center overflow-hidden",
                          staticStyle: { height: "160px" }
                        },
                        [
                          _c("i", {
                            staticClass:
                              "fa fa-building fa-3x text-secondary mb-2"
                          }),
                          _vm._v(" "),
                          _c(
                            "span",
                            {
                              staticClass:
                                "font-weight-bold text-muted text-uppercase tracking-wider small"
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.$t(
                                      "visitorManagement.advanceRegistration.company"
                                    )
                                  ) +
                                  "\n          "
                              )
                            ]
                          )
                        ]
                      )
                    ]
                  : [
                      _c(
                        "div",
                        {
                          staticClass:
                            "w-100 d-flex justify-content-center overflow-hidden rounded mb-2",
                          staticStyle: { height: "160px" }
                        },
                        [
                          _c("img", {
                            staticClass: "img-fluid",
                            staticStyle: {
                              "max-height": "100%",
                              "object-fit": "contain"
                            },
                            attrs: {
                              src: _vm.imageUrl,
                              alt: "Visitor Management"
                            }
                          })
                        ]
                      )
                    ],
                _vm._v(" "),
                _c("div", { staticClass: "info-text text-secondary w-100" }, [
                  _c("p", { staticClass: "font-weight-bold mb-2" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "visitorManagement.advanceRegistration.welcomeTitle"
                          )
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("p", { staticClass: "small" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t(
                            "visitorManagement.advanceRegistration.welcomeInstruction"
                          )
                        ) +
                        "\n          "
                    )
                  ])
                ])
              ],
              2
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex-grow-1 w-100" },
              [
                _vm.groupSurveyExtension
                  ? _c("GroupEditor", {
                      ref: "groupEditor",
                      attrs: {
                        allUsers: [],
                        availableSalutations: [],
                        group: _vm.groupSurveyExtension,
                        groupSelector: "group",
                        groupCopyFunction: e =>
                          _vm.GroupSurveyExtension.fromJS(e),
                        groupSaveFunction: _vm.saveGroup,
                        hiddenTabs: ["users"],
                        tabTitles: new Map([
                          [
                            "usersExternal",
                            _vm.$t(
                              "visitorManagement.advanceRegistration.tabs.usersExternal"
                            )
                          ]
                        ]),
                        hidePinned: true,
                        hideExternalUserDisabled: true,
                        hideMassSelection: !_vm.canMultipleSelection
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "generalNameLabel",
                            fn: function() {
                              return [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "visitorManagement.advanceRegistration.reasonOfVisit"
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "generalAfter",
                            fn: function({ group }) {
                              return [
                                _c("GeneralAfter", {
                                  attrs: {
                                    group: group,
                                    canToggleEnableScanEntry:
                                      _vm.canToggleEnableScanEntry,
                                    hideApprovalStati: true
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "datePickerText",
                                        fn: function({ startDate, endDate }) {
                                          return [
                                            !startDate || !endDate
                                              ? [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.$t(
                                                        "visitorManagement.advanceRegistration.selectDate"
                                                      )
                                                    )
                                                  )
                                                ]
                                              : [
                                                  _vm._v(
                                                    "\n                  " +
                                                      _vm._s(
                                                        _vm.formatDateTime(
                                                          startDate
                                                        )
                                                      ) +
                                                      " - " +
                                                      _vm._s(
                                                        _vm.formatDateTime(
                                                          endDate
                                                        )
                                                      ) +
                                                      "\n                "
                                                  )
                                                ]
                                          ]
                                        }
                                      },
                                      {
                                        key: "approvals",
                                        fn: function({ group }) {
                                          return [
                                            _c("label", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.$t(
                                                    "survey.group.model.approvals"
                                                  )
                                                )
                                              )
                                            ]),
                                            _vm._v(" "),
                                            _c(
                                              "ApprovalGroupSelectCheckBoxes",
                                              {
                                                attrs: {
                                                  groupSurveyExtension: group
                                                }
                                              }
                                            )
                                          ]
                                        }
                                      },
                                      {
                                        key: "informationGroups",
                                        fn: function() {
                                          return [_c("div")]
                                        },
                                        proxy: true
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                })
                              ]
                            }
                          },
                          {
                            key: "editModalTabs",
                            fn: function({ group }) {
                              return [
                                !_vm.surveySelectionViaGroups
                                  ? _c(
                                      "TabSlot",
                                      {
                                        attrs: {
                                          id: "surveys",
                                          title: _vm.$t("survey.group.surveys"),
                                          order: 30
                                        }
                                      },
                                      [
                                        _c("GroupSurveyEditor", {
                                          attrs: { group: group }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.surveySelectionViaGroups
                                  ? _c(
                                      "TabSlot",
                                      {
                                        attrs: {
                                          id: "surveysFromGroup",
                                          title: _vm.$t(
                                            "survey.group.surveysFromGroups"
                                          ),
                                          order: -10
                                        }
                                      },
                                      [
                                        _c("GroupSurveyGroupSelector", {
                                          ref: "groupSurveyGroupSelector",
                                          attrs: { group: group },
                                          on: {
                                            change: function($event) {
                                              _vm.selectedSurveyGroups = $event
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ],
                        null,
                        false,
                        2455951379
                      )
                    })
                  : _vm._e()
              ],
              1
            )
          ]
        ),
        _vm._v(" "),
        _vm.$te("visitorManagement.advanceRegistration.closingInstruction")
          ? _c("div", {
              staticClass: "mb-3",
              domProps: { innerHTML: _vm._s(_vm.formattedInstruction()) }
            })
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "d-flex flex-row border-top pt-3" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary ml-auto w-100 w-sm-auto",
              attrs: { disabled: !_vm.canSave || _vm.saving },
              on: { click: _vm.onSave }
            },
            [
              !_vm.saving
                ? _c("i", { staticClass: "fa fa-save" })
                : _c("Spinner", { attrs: { small: true } }),
              _vm._v("\n        " + _vm._s(_vm.$t("btnSave")) + "\n      ")
            ],
            1
          )
        ])
      ])
    : _c(
        "div",
        [
          _c("CenterOnParent", [
            _c("div", { staticClass: "mb-3 text-success" }, [
              _c("i", { staticClass: "fa fa-check-circle fa-4x" })
            ]),
            _vm._v(" "),
            _c("h3", { staticClass: "font-weight-bold mb-2" }, [
              _vm._v(
                "\n          " +
                  _vm._s(
                    _vm.$t("visitorManagement.advanceRegistration.successTitle")
                  ) +
                  "\n        "
              )
            ]),
            _vm._v(" "),
            _c(
              "p",
              {
                staticClass: "text-secondary mb-4",
                staticStyle: { "max-width": "450px" }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "visitorManagement.advanceRegistration.successMessage"
                      )
                    ) +
                    "\n        "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-primary",
                on: { click: _vm.resetForm }
              },
              [
                _vm._v(
                  "\n          " +
                    _vm._s(
                      _vm.$t(
                        "visitorManagement.advanceRegistration.registerAnother"
                      )
                    ) +
                    "\n        "
                )
              ]
            )
          ])
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }